import React from 'react';
import {Video, Formatted} from 'components';
import {config} from 'helpers';

export function PurposeGoDeeper() {
  return (
    <Formatted className="medium-spacing">
      <Video.Video src={config.videos.identity.purpose2} />
      <p>At this point, you may have a strong sense of your purpose. Or perhaps you are starting to see hints of what it might be. Take that idea, solid or vague, and find one way to live that purpose each day for two weeks. Figure out a way to make yourself accountable (add it to your to-do list, write in your calendar, send yourself an email ... whatever works for you). If you are feeling particularly bold, tell five people a week about your purpose!</p>
      <p>At the end of the two weeks, go back and read your answers to the questions in the Purpose section and see how you feel now. Are things clearer? Less clear? Where are you now?</p>
      <p>Whatever the outcome, congratulate and reward yourself for taking this step!</p>
    </Formatted>
  );
}
